namespace Matrix.Indexation {
    export interface IndexConstituentRorForm {
        IndexationProfileCode: Serenity.StringEditor;
        CompositeCode: Serenity.StringEditor;
        IndexCode: Serenity.StringEditor;
        BaseDate: Serenity.DateEditor;
        EffectiveDate: Serenity.DateEditor;
        SourceCode: Serenity.StringEditor;
        LocalReturn: Serenity.DecimalEditor;
        CurrencyReturn: Serenity.DecimalEditor;
        HedgedReturn: Serenity.DecimalEditor;
        UnhedgedReturn: Serenity.DecimalEditor;
        TotalReturn: Serenity.DecimalEditor;
        DefaultSortOrder: Serenity.IntegerEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class IndexConstituentRorForm extends Serenity.PrefixedContext {
        static formKey = 'Indexation.IndexConstituentRor';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IndexConstituentRorForm.init)  {
                IndexConstituentRorForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.IntegerEditor;
                var w4 = StaticTextBlock;
                var w5 = ReadOnlyDateTime;

                Q.initFormType(IndexConstituentRorForm, [
                    'IndexationProfileCode', w0,
                    'CompositeCode', w0,
                    'IndexCode', w0,
                    'BaseDate', w1,
                    'EffectiveDate', w1,
                    'SourceCode', w0,
                    'LocalReturn', w2,
                    'CurrencyReturn', w2,
                    'HedgedReturn', w2,
                    'UnhedgedReturn', w2,
                    'TotalReturn', w2,
                    'DefaultSortOrder', w3,
                    'CreatedBy', w4,
                    'CreatedWhen', w5,
                    'UpdatedBy', w4,
                    'UpdatedWhen', w5,
                    'Version', w4
                ]);
            }
        }
    }
}
